(() => {
  const MOBILE_QUERY = '(max-width: 767px)';
  const MAX_IMAGES = 6;
  const mediaQuery = window.matchMedia(MOBILE_QUERY);

  function imageKey(image) {
    return image?.getAttribute('srcset') || image?.getAttribute('src') || '';
  }

  function isInsideMobileProductSlider(mediaLink) {
    const slider = mediaLink.closest('slider-element');
    if (!slider) return false;

    return slider.classList.contains('slider--tablet') || slider.classList.contains('slider--mobile');
  }

  function collectImages(mediaLink) {
    const images = [];
    const seen = new Set();

    const addImage = (image) => {
      if (!image || images.length >= MAX_IMAGES) return;

      const key = imageKey(image);
      if (!key || seen.has(key)) return;

      seen.add(key);
      images.push(image);
    };

    const directImage = Array.from(mediaLink.children).find((child) => child.tagName === 'IMG');
    addImage(directImage);

    const template = Array.from(mediaLink.children).find((child) => child.tagName === 'TEMPLATE');
    if (template?.content) {
      Array.from(template.content.children).forEach((item) => {
        if (images.length >= MAX_IMAGES) return;
        if (item.querySelector('video, iframe, product-video')) return;
        addImage(item.querySelector('img'));
      });
    }

    if (images.length < 2) {
      addImage(mediaLink.querySelector(':scope > .product-card__secondary img'));
    }

    return images.slice(0, MAX_IMAGES);
  }

  function buildGallery(mediaLink) {
    if (!mediaQuery.matches) return;
    if (mediaLink.dataset.lumistrateMobileGallery === 'ready') return;
    if (isInsideMobileProductSlider(mediaLink)) return;

    const sourceImages = collectImages(mediaLink);
    if (sourceImages.length < 2) return;

    const gallery = document.createElement('div');
    gallery.className = 'lumistrate-card-mobile-gallery';

    const track = document.createElement('div');
    track.className = 'lumistrate-card-mobile-gallery__track';

    sourceImages.forEach((sourceImage, index) => {
      const slide = document.createElement('span');
      slide.className = 'lumistrate-card-mobile-gallery__slide';

      const image = sourceImage.cloneNode(true);
      image.removeAttribute('is');
      image.loading = index === 0 ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.draggable = false;
      image.removeAttribute('fetchpriority');

      slide.appendChild(image);
      track.appendChild(slide);
    });

    gallery.appendChild(track);

    const dots = document.createElement('div');
    dots.className = 'lumistrate-card-mobile-gallery__dots';
    dots.setAttribute('aria-hidden', 'true');

    const dotElements = sourceImages.map((_, index) => {
      const dot = document.createElement('span');
      dot.className = `lumistrate-card-mobile-gallery__dot${index === 0 ? ' is-active' : ''}`;
      dots.appendChild(dot);
      return dot;
    });

    let frameRequested = false;
    const updateDots = () => {
      frameRequested = false;
      const slideWidth = track.clientWidth || 1;
      const activeIndex = Math.max(
        0,
        Math.min(dotElements.length - 1, Math.round(track.scrollLeft / slideWidth))
      );

      dotElements.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    };

    track.addEventListener(
      'scroll',
      () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(updateDots);
      },
      { passive: true }
    );

    let startX = 0;
    let startY = 0;
    let horizontalSwipe = false;

    track.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches[0];
        startX = touch?.clientX || 0;
        startY = touch?.clientY || 0;
        horizontalSwipe = false;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;

        const deltaX = Math.abs(touch.clientX - startX);
        const deltaY = Math.abs(touch.clientY - startY);
        if (deltaX > 8 && deltaX > deltaY) horizontalSwipe = true;
      },
      { passive: true }
    );

    mediaLink.addEventListener(
      'click',
      (event) => {
        if (!horizontalSwipe) return;
        event.preventDefault();
        event.stopPropagation();
        horizontalSwipe = false;
      },
      true
    );

    track.addEventListener(
      'touchend',
      () => {
        window.setTimeout(() => {
          horizontalSwipe = false;
        }, 250);
      },
      { passive: true }
    );

    mediaLink.appendChild(gallery);
    mediaLink.appendChild(dots);
    mediaLink.classList.add('lumistrate-mobile-gallery-ready');
    mediaLink.dataset.lumistrateMobileGallery = 'ready';
  }

  function scan(root = document) {
    if (!mediaQuery.matches) return;

    if (root.matches?.('.product-card__media > a.media')) {
      buildGallery(root);
    }

    root.querySelectorAll?.('.product-card__media > a.media').forEach(buildGallery);
  }

  function start() {
    scan(document);

    const observer = new MutationObserver((mutations) => {
      if (!mediaQuery.matches) return;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) scan(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    mediaQuery.addEventListener?.('change', (event) => {
      if (event.matches) scan(document);
    });

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
